import { ExternalComponentErrorType } from '../../../ExternalComponent.types';

export const DEFAULT_ERROR =
  'Make sure you’ve added all required props and check your code for errors in the browser console.';

export const ALERT_STROKE_COLOR = '#EE4437';
export const DEFAULT_STROKE_COLOR = '#000';

export const errorTypeToSkinAndKey: Record<
  ExternalComponentErrorType,
  Record<'key' | 'skin', string>
> = {
  [ExternalComponentErrorType.Runtime]: {
    skin: 'warning',
    key: 'ExternalComponent_wide_settings_render_error',
  },
  [ExternalComponentErrorType.WrongExport]: {
    skin: 'alert',
    key: 'ExternalComponent_wide_settings_wrong_export_error_title',
  },
  [ExternalComponentErrorType.MissingExport]: {
    skin: 'alert',
    key: 'ExternalComponent_wide_settings_wrong_export_error_title',
  },
  [ExternalComponentErrorType.Timeout]: {
    skin: 'alert',
    key: 'ExternalComponent_wide_settings_fetch_error_title',
  },
  [ExternalComponentErrorType.Fetch]: {
    skin: 'alert',
    key: 'ExternalComponent_wide_settings_fetch_error_title',
  },
  [ExternalComponentErrorType.Bundling]: {
    skin: 'alert',
    key: 'ExternalComponent_wide_settings_bundling_failed_code_error_title',
  },
  [ExternalComponentErrorType.FileNotFound]: {
    skin: 'alert',
    key: 'ExternalComponent_wide_settings_file_not_found_error_title',
  },
  [ExternalComponentErrorType.UnsupportedBrowser]: {
    skin: '',
    key: 'ExternalComponent_render_error_on_stage_error_message_incognito',
  },
  [ExternalComponentErrorType.UserOfUserDisplay]: {
    skin: '',
    key: 'ExternalComponent_UoU_message_component_not_loading',
  },
};
